export const SUMMARY_CARDS = [
  {
    icon: 'fa-coins',
    title: 'Sin costo',
    description:
      'El usuario no debe realizar pagos para presentar una PQRSF mediante este canal.',
  },
  {
    icon: 'fa-calendar-check',
    title: 'Atención oportuna',
    description:
      'Las solicitudes serán gestionadas dentro de los términos definidos por la normatividad aplicable.',
  },
  {
    icon: 'fa-magnifying-glass',
    title: 'Trazabilidad',
    description:
      'El número de radicado permite identificar la solicitud y facilitar su seguimiento.',
  },
  {
    icon: 'fa-lock',
    title: 'Protección de la información',
    description:
      'Los datos serán utilizados para gestionar el trámite, comunicarse con el usuario y conservar evidencia de la atención.',
  },
];
